import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'
import { twMerge } from 'tailwind-merge'

import ArrowRightIcon from '@/assets/icons/icon-arrow-right.svg'
import type { ButtonProps } from '@/components/ui/button'
import { Button } from '@/components/ui/button'

import { useCampaigns } from '../state/hooks'

const variants = cva(
  'group flex flex-1 h-max border-[1.2px] gap-3 rounded-xl hover:border-[#CC2030] hover:bg-[#CC2030] dark:hover:border-[#CC2030] dark:hover:bg-[#CC2030] hover:text-white py-2 sm:py-3 text-lg',
  {
    variants: {
      variant: {
        white: 'bg-white text-secondary-900',
        transparent: 'bg-transparent text-white dark:border-white',
      },
    },
    defaultVariants: {
      variant: 'white',
    },
  },
)

type Props = Omit<ButtonProps, 'variant'> & VariantProps<typeof variants>

export const CampaignPromotionButton = ({
  variant,
  className,
  children,
  ...buttonProps
}: Props) => {
  const { currentDiscount } = useCampaigns()

  const combinedClassName = twMerge(variants({ variant }), className)

  return (
    <Button
      variant="outline"
      className={combinedClassName}
      {...buttonProps}
    >
      {children}
      <div className="relative shrink-0 overflow-hidden rounded-full bg-[#E3262F] px-3 py-[5px] text-white">
        <ArrowRightIcon className="absolute left-1/2 top-0.5 -translate-x-20 transition-transform duration-500 group-hover:-translate-x-1/2" />
        <p className="text-xs font-semibold leading-[18px] transition-transform duration-500 group-hover:translate-x-20">
          {currentDiscount}% OFF
        </p>
      </div>
    </Button>
  )
}
